// extracted by mini-css-extract-plugin
export default {"table":"ReportPage_table__Cafs9"};